import React from "react";

import { Filter, useTranslate } from "react-admin";

import TextInputEx from "components/_extensions/react-admin/input/TextInputEx";
import { DateTimeInput, NumberInputEx } from "components/inputs";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { ClientNotificationDeliveryStatus } from "entities/ClientNotificationDeliveryStatus";
import { NotificationSubscriptionEventType } from "entities/NotificationSubscriptionEventType";

export const Filters = (props) => {
	const translate = useTranslate();
	return (
		<Filter {...props}>
			<SelectEnumInput
				source="status"
				enumName="client_notification_delivery_status"
				resettable
				enumObj={ClientNotificationDeliveryStatus}
				style={{ minWidth: 200 }}
			/>
			<SelectEnumInput
				source="event_type"
				enumName="notification_subscription"
				resettable
				enumObj={NotificationSubscriptionEventType}
				style={{ minWidth: 200 }}
			/>
			<NumberInputEx source="subscription_id" />
			<TextInputEx source="delivery_id" />
			<DateTimeInput
				label={translate("osfc.filters.dates.date_from")}
				source="created_at_utc:gte"
				withLocalTimeZone
			/>
			<DateTimeInput
				label={translate("osfc.filters.dates.date_to")}
				source="created_at_utc:lte"
				withLocalTimeZone
			/>
			<DateTimeInput
				label={translate("osfc.filters.dates.from_sent_date")}
				source="last_attempt_at_utc:gte"
				withLocalTimeZone
			/>
			<DateTimeInput
				label={translate("osfc.filters.dates.to_sent_date")}
				source="last_attempt_at_utc:lte"
				withLocalTimeZone
			/>
		</Filter>
	);
};
